// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Get these from Step 1 (Project Settings > API)
const supabaseUrl = 'https://nxkfkccrnkqanqvfovch.supabase.co';
    //replace with 'https://nxkfkccrnkqanqvfovch.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im54a2ZrY2NybmtxYW5xdmZvdmNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0NTAwNjYsImV4cCI6MjA3NTAyNjA2Nn0.FKROJQlmTIKREvLqZpVgq8z5fFJZT1kBclOw0Ak9Tbc';
    //replace with 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im54a2ZrY2NybmtxYW5xdmZvdmNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0NTAwNjYsImV4cCI6MjA3NTAyNjA2Nn0.FKROJQlmTIKREvLqZpVgq8z5fFJZT1kBclOw0Ak9Tbc'

// This one line creates your "backend" client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);